<template>
	<div class="container">
		<div class="left" :style="{width:leftWidth}">
			<a v-if="!isCollapse" href="/admin/index"><img class="left-logo" src="@/assets/logo.png"/></a>
			<div class="collapse" @click="toCollapse">
				<img src="@/assets/collapse_icon.png"/>
			</div>
			<el-menu router :collapse="isCollapse" :default-active="activeIndex" background-color="#f6f8fc">
				<el-submenu index="1">
					<template slot="title">
						<i class="el-icon-menu"></i>
						<span>活动管理</span>
					</template>
					<el-menu-item index="/admin/activityList">
						<span>活动管理</span>
					</el-menu-item>
					<el-menu-item index="/admin/statisticsArea?type=0">
						<span>触达区域统计</span>
					</el-menu-item>
					<el-menu-item index="/admin/statisticsArea2?type=3">
						<span>触达学校统计</span>
					</el-menu-item>
				</el-submenu>
				<el-submenu index="2">
					<template slot="title">
						<i class="el-icon-s-ticket"></i>
						<span>投票管理</span>
					</template>
					<el-menu-item index="/admin/voteList">
						<span>投票管理</span>
					</el-menu-item>
				</el-submenu>
			</el-menu>
		</div>
		<div class="main">
			<div class="top" :style="{left:leftWidth}">
				<div class="top-l">
					<h3>{{companyName}}</h3>
				</div>
				<div class="top-r">
					<div class="line" v-if="isShowReturn"></div>
					<div class="space" v-if="isShowReturn" @click="toReturn">
						<img src="@/assets/header_icon_05.png"/>
						<span>返回</span>
					</div>
					<div class="line" v-if="isShowReturn"></div>
					<div class="space" v-if="isShowReturn" @click="shuaxin">
						<img src="@/assets/header_icon_06.png"/>
						<span>刷新</span>
					</div>
					<div class="line"></div>
					<ul>
						<li>
							<img src="@/assets/header_icon_03.png"/>
						</li>
						<li>
							<el-dropdown @command="handleCommand">
							  <img src="@/assets/header_icon_02.png"/>
							  <el-dropdown-menu slot="dropdown">
							    <el-dropdown-item command="userinfo">账户信息</el-dropdown-item>
							    <el-dropdown-item command="modifypassword">修改密码</el-dropdown-item>
							  </el-dropdown-menu>
							</el-dropdown>
						</li>
						<li>
							<img src="@/assets/header_icon_01.png"/>
						</li>
					</ul>
					<div class="line"></div>
					<div class="space" @click="loginOut">
						<img src="@/assets/header_icon_04.png"/>
						<span>退出</span>
					</div>
				</div>
			</div>
			<div class="content">
				<router-view></router-view>
			</div>
		</div>
		<!--个人信息弹窗-->
		<el-dialog title="修改账户信息" :visible.sync="userDialog" width="40%" @close="userDialog=false">
			<el-form :inline="true" class="add-dialog" label-width="120px">
				<el-form-item label="登录账号">
					<el-input v-model="userName" disabled></el-input>
				</el-form-item>
				<el-form-item label="公司名称" prop="accountName">
					<el-input v-model="accountName"></el-input>
				</el-form-item>
				<el-form-item label="Logo" prop="logoFileUrl">
					<el-upload :action=uploadUrl list-type="picture-card" accept=".jpg,.jpeg,.png,.gif" :limit="1"
						:file-list="logoList" :before-upload="beforeUpload" :on-success="handleSuccessLogo"
						:on-preview="handlePreview" :on-exceed="handleExceedLogo" :on-remove="handleRemoveLogo">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="营业执照" prop="businessLicense">
					<el-upload :action=uploadUrl list-type="picture-card" accept=".jpg,.jpeg,.png,.gif" :limit="1"
						:file-list="businessList" :before-upload="beforeUpload" :on-success="handleSuccessBusiness"
						:on-preview="handlePreview" :on-exceed="handleExceedBus" :on-remove="handleRemoveBusiness">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="电子公章" prop="elecSeal">
					<el-upload :action=uploadUrl list-type="picture-card" accept=".jpg,.jpeg,.png,.gif" :limit="1"
						:file-list="elecSealList" :before-upload="beforeUpload" :on-success="handleSuccessElecSeal"
						:on-preview="handlePreview" :on-exceed="handleExceedElec" :on-remove="handleRemoveElec">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="联系人" prop="contactPerson">
					<el-input v-model="contactPerson"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="contactPhone">
					<el-input v-model="contactPhone"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="flex-end">
						<el-button size="mini" type="primary" @click="userDialog=false">取消</el-button>
						<el-button size="mini" type="primary" @click="toaccountInfo">确定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!--个人信息弹窗-->
		<el-dialog title="修改密码" :visible.sync="passwordDialog" width="40%" @close="passwordDialog=false">
			<el-form :model="formInfo" :inline="true" :rules="rules" ref="ruleForm" class="add-dialog" label-width="120px">
				<el-form-item label="原始密码" prop="oldPassword">
					<el-input v-model="formInfo.oldPassword"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="password">
					<el-input v-model="formInfo.password"></el-input>
				</el-form-item>
				<el-form-item label="确认新密码" prop="confirmPassword">
					<el-input v-model="formInfo.confirmPassword"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="flex-end">
						<el-button size="mini" type="primary" @click="passwordDialog=false">取消</el-button>
						<el-button size="mini" type="primary" @click="toConfirmPassword">确定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!--上传图片预览-->
		<el-dialog title="图片预览" :modal="false" :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.css'
	import Title from '@/components/title'
	import qs from 'qs'
	import { post,config, ajaxParam } from '@/units/request.js'
	export default {
		name: 'Admin',
		components: {
			Title
		},
		data(){
			return {
				uploadUrl: '', //图片上传地址
				pageHeight: '400px',
				activeIndex: '1',
				isShowReturn: false,
				activePath: '',
				isCollapse: false,
				leftWidth: '160px',
				companyName: '',
				accountName: '', //公司名称
				businessList: [],
				elecSealList: [],
				logoList: [],
				businessLicense: '', //  营业执照
				elecSeal: '', //  电子公章
				contactPerson: '', //  联系人
				contactPhone: '', // 联系电话
				logoFileUrl: '', //logo
				dialogVisible: false,
				dialogImageUrl: '',
				companyModel: {},
				userDialog: false,
				passwordDialog: false,
				nickName: '',
				phone: '',
				userName: '',
				userId: '',
				formInfo: {
					oldPassword: '',
					password: '',
					confirmPassword: ''
				},
				rules: {
					oldPassword: [{
						required: true,
						message: '请输入原始密码',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
					confirmPassword: [{
						required: true,
						message: '请确认新密码',
						trigger: 'blur'
					}]
				}
			}
		},
		created(){
			this.userName = localStorage.getItem('username')
			this.uploadUrl = config.baseUrl + 'admin/sys/upload'
			this.userId = localStorage.getItem('userId')
			this.nickName = localStorage.getItem('nickName')
			setTimeout(()=>{
				this.initSwiper()
			},300)
			this.getCompany()
		},
		mounted(){
			// let pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
			// this.pageHeight = pageHeight+'px'
			this.activePath = this.$route.path
			if(this.activePath!='/admin/index') {
				this.isShowReturn = true
			} else {
					this.isShowReturn = false
				}
		},
		watch: {
			//路径改变重新刷新数据
			$route(to, from) {
				this.activePath = to.path
				if(this.activePath!='/admin/index') {
					this.isShowReturn = true
				} else {
					this.isShowReturn = false
				}
			}
		},
		methods: {
			//获取公司信息
			async getCompany(){
				let param = {
					id: localStorage.getItem('companyId')||''
				}
				ajaxParam(param)
				const res = await post('admin/index/getCompany', qs.stringify(param))
				if (res.data.code == 200) {
					let model = res.data.entity
					this.accountName = model.companyName
					this.contactPhone = model.contactPhone
					this.contactPerson = model.contactPerson
					this.companyName = model.companyName
					if(model.businessLicense) {
						this.businessLicense = model.businessLicense
						this.businessList.push({
							url: model.businessLicense
						})
					}
					if(model.elecSeal) {
						this.elecSeal = model.elecSeal
						this.elecSealList.push({
							url: model.elecSeal
						})
					}
					if(model.logoFileUrl) {
						this.logoFileUrl = model.logoFileUrl
						this.logoList.push({
							url: model.logoFileUrl
						})
					}
				} else{
					this.$message.error(res.data.msg)
				}
			},
			shuaxin(){
				window.location.reload()
			},
			initSwiper(){
				new Swiper(".banner", {
					autoplay: 6000,
					autoplayDisableOnInteraction : false,
					// 轮播效果,默认为平滑轮播
					effect: "slide",
					pagination: '.swiper-pagination',
					paginationClickable :true
				})
			},
			toReturn(){
				this.$router.go(-1)
			},
			toCollapse(){
				this.isCollapse = !this.isCollapse
				if(this.isCollapse){
					this.leftWidth = '64px'
				}
				else{
					this.leftWidth = '160px'
				}
			},
			//退出登录
			loginOut(){
				this.$confirm('确定要退出登录？','温馨提示',{
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(async()=>{
				    localStorage.removeItem('user')
				    localStorage.removeItem('companyId')
				    localStorage.removeItem('token')
					localStorage.removeItem('companyName')
				    this.$router.push('/login')
				}).catch(()=>{

				})
			},
			handleCommand(e){
				console.log(e)
				if(e=='userinfo') {
					this.userDialog = true
				}
				if(e=='modifypassword') {
					this.passwordDialog = true
				}
			},
			//修改密码
		    toConfirmPassword(){
				this.$refs.ruleForm.validate( async valid =>{
					if(valid){
						let param = {
							userId: this.userId,
							oldPassword: this.formInfo.oldPassword,
							password: this.formInfo.password
						}
						ajaxParam(param)
						const res = await post('admin/index/changePassword', qs.stringify(param))
						if (res.data.code == 200) {
							this.$message.success('修改密码成功！')
							this.passwordDialog = false
						} else{
							this.$message.error(res.data.msg)
						}
					}
				})

			},
			//修改账号信息
			async toaccountInfo() {
				let param = {
					id: localStorage.getItem('companyId')||'',
					companyName: this.accountName,
					businessLicense: this.businessLicense,
					elecSeal: this.elecSeal,
					contactPerson: this.contactPerson,
					contactPhone : this.contactPhone,
					logoFileUrl: this.logoFileUrl
				}
				ajaxParam(param)
				const res = await post('admin/index/updateCompany', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('修改信息成功！')
					this.userDialog = false
					this.companyName = this.accountName
					window.location.href = '/admin/index'
				}
			},
			//修改个人信息
			async toConfirmUserInfo() {
				let param = {
					userId: this.userId,
					nickName: this.nickName,
					phone: this.phone
				}
				ajaxParam(param)
				const res = await post('admin/index/changeMyInfo', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('修改个人信息成功！')
					localStorage.setItem('nickName', this.nickName)
					this.userDialog = false
				}
			},
			//账号修改上传相关
			beforeUpload(file) {
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
				const whiteList = ['jpg', 'jpeg', 'png', 'gif']
				if (whiteList.indexOf(fileSuffix) == -1) {
					this.$message.error("只能上传jpg,jpeg,png,gif格式图片！")
					return false
				}
			},
			handleSuccessBusiness(res) {
				let entity = res.entity
				this.businessLicense = entity.fileUrl
			},
			handlePreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleRemoveBusiness(file) {
				console.log(file)
				this.businessLicense = ''
			},
			handleSuccessElecSeal(res) {
				let entity = res.entity
				this.elecSeal = entity.fileUrl
			},
			handleSuccessLogo(res){
				let entity = res.entity
				this.logoFileUrl = entity.fileUrl
			},
			handleRemoveLogo(file) {
				this.logoFileUrl = ''
			},
			handleRemoveElec(file){
				this.elecSeal = ''
			},
			handleExceedLogo(e){
				this.$message.error('请先删除已存在Logo后再上传！')
			},
			handleExceedElec(){
				this.$message.error('请先删除已存在电子公章后再上传！')
			},
			handleExceedBus(){
				this.$message.error('请先删除已存在营业执照后再上传！')
			}
		}
	}
</script>
<style lang="less">
	html,body,#app{
		height: 100%
	}
</style>
<style scoped lang="less">
	.list li /deep/ .title{
		padding: 0!important;
	}
	.container{
		display: flex;
		justify-content: space-between;
		height: 100%;
		.left{
			width: 160px;
			background: #f6f8fc;
			border-right: 1px solid #e3e3e3;
			overflow: hidden;
			.left-logo{
				display: block;
				width: 120px;
				margin: 20px auto;
			}
			.collapse{
				margin-bottom: 10px;
				padding: 5px 0 10px;
				cursor: pointer;
				img{
					display: block;
					width: 18px;
					height: 18px;
					margin: 0 auto;
				}
			}
			.el-menu-item:hover, .el-menu-item.is-active{
				color: #fff;
				background-color: #eb6b1b !important;
			}
		}
		.main{
			flex: 1;
			background: #f5f6f8;
			height: 100%;
			overflow-y: auto;
			box-sizing: border-box;
			.top{
				height: 69px;
				background: #fff;
				border-bottom: 1px solid #e3e3e3;
				position: fixed;
				left: 160px;
				right: 0px;
				z-index: 999;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 20px;
				.top-l{
					h3{
						font-weight: bold;
					}
				}
				.top-r{
					display: flex;
					align-items: center;
					ul{
						display: flex;
						align-items: center;
						padding-right: 10px;
						li{
							padding-left: 15px;
						}
					}
					.space{
						display: flex;
						align-items: center;
						padding: 0 15px;
						font-size: 13px;
						cursor: pointer;
						img{
							width: 18px;
							height: 18px;
							margin-right: 1px;
						}
					}
					.line{
						height: 14px;
						width: 1px;
						overflow: hidden;
						background: #E3E3E3;
					}
				}
			}
			.content{
				width:auto;
				margin:80px 20px 20px;
				box-sizing: border-box;
				.part{
					display: flex;
					justify-content: space-between;
					margin-bottom: 20px;
				}
				.company-wrap{
					width: 30%;
					background: #fff;
					border: 1px solid #e4e4e4;
					border-radius: 4px;
					margin-right: 20px;
					padding: 20px;
					box-sizing: border-box;
					.company{
						height: 230px;
						background: #eb6b1b;
						border-radius: 5px;
					}
				}
				.data-wrap{
					flex: 1;
					background: #fff;
					border: 1px solid #e4e4e4;
					border-radius: 4px;
					padding: 20px;
					box-sizing: border-box;
					.data{
						.data-top{
							height: 110px;
							background: #faf6f5;
							border-radius: 5px;
						}
						.data-bom{
							display: flex;
							justify-content: space-between;
							margin-top: 10px;
							.data-bom-list{
								width: 24%;
								height: 110px;
								background: #ffdcc6;
								margin-right: 1%;
							}
							.data-bom-list:last-of-type{
								margin-right: 0;
							}
						}
					}
				}
				.banner-wrap{
					background: #fff;
					border: 1px solid #e4e4e4;
					border-radius: 4px;
					margin-right: 20px;
					padding: 20px;
					box-sizing: border-box;
					width: 60%;
					.banner{
						height: 272px;
						img{
							width:100%;
							height: 100%;
						}
					}
				}
				.activity-wrap{
					flex: 1;
					background: #fff;
					border: 1px solid #e4e4e4;
					border-radius: 4px;
					padding: 20px;
					.list{
						display: flex;
						flex-wrap: wrap;
						justify-content: space-between;
						li{
							width: 48%;
							background: #faf6f5;
							border-radius: 5px;
							margin-top: 10px;
							padding: 10px;
							box-sizing: border-box;

							.list-title{
								font-weight: 500;
								font-size: 18px;
								color: #37383c;
								letter-spacing: 1.29px;
								line-height: 32px;
								white-space: nowrap;
								text-overflow: ellipsis;
								overflow: hidden;
							}
							.list-time{
								color: #666;
								font-size: 12px;
							}
							.list-operate{
								display: flex;
								justify-content: space-between;
								font-size: 12px;
							}
						}
					}
				}
				.wrap{
					background: #fff;
					border: 1px solid #e4e4e4;
					border-radius: 4px;
					padding: 20px;
					.list-wrap{
						display: flex;
						justify-content: space-between;
						li{
							width: 49%;
							background: #ffe9d8;
							border-radius: 10px;
							padding: 20px;
							box-sizing: border-box;
							.tables{
								background: #fff;
								padding: 20px;
								table{
									width: 100%;
									th{
										background: #f5f6f8;
										padding: 10px;
										text-align: left;
									}
									td{
										padding: 5px;
										border-bottom: 1px solid #f6f7f9;
									}
								}
							}
						}
					}
				}
			}
		}

	}
	/deep/ .el-form-item {
		margin-bottom: 20px;
	}
	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}

	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}
	/deep/ .el-dialog__header {
		padding-top: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #DBDCDC !important;
	}
	/deep/ .el-dialog__body {
		//padding-top: 20px;
		padding: 15px 20px;
	}
	.el-dialog__wrapper /deep/ .el-form--inline .el-form-item{
		width: 100%;
		display: flex;
	}
	.el-dialog__wrapper /deep/ .el-form-item__content{
		flex: 1
	}
	.flex-end{
		display: flex;
		justify-content: flex-end;
	}
	.manage-btns{
		color: #EB6B1B;
		span{
			cursor: pointer;
		}
		.space{
			margin: 0 5px;
			cursor: default;
		}
	}
	/deep/ .el-menu{
		border-right: none
	}
	/deep/.el-submenu .el-menu-item{
		min-width: auto;
		height: 44px;
		line-height: 44px;
		margin: 2px 10px;
		padding: 0 0 0 30px!important;
		border-radius: 12px;
	}
	.add-dialog /deep/ .el-input__inner{
		height: 32px;
		line-height: 32px;
	}
	.add-dialog /deep/ .el-form-item{
		margin-bottom: 10px;
	}
	/deep/ .el-upload-list--picture-card .el-upload-list__item,
	/deep/ .el-upload--picture-card {
		width: 60px;
		height: 60px;
		line-height: 60px;
	}
</style>
